// extracted by mini-css-extract-plugin
export default {"alert":"alert_alert__3Y7Nx","alert-yellow":"alert_alert-yellow__aS2Q4","alert-green":"alert_alert-green__KztRQ","alert-red":"alert_alert-red__3zdd0"};